export default __webpack_public_path__ + "static/media/miguel-lopes-14.a1eb8d8e.jpg";